module.exports = __webpack_public_path__ + "img/swap_active.7e8d009.png";